export const state = () => (require('@pleinair/bigcolony-vue/store/product/_state')())
export const mutations = require('@pleinair/bigcolony-vue/store/product/_mutations')
export const actions = require('@pleinair/bigcolony-vue/store/product/_actions')